var _path, _path2, _path3, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C12.7294 1 13.4009 1.39707 13.7524 2.03616L23.7524 20.218C24.0932 20.8376 24.0815 21.5911 23.7216 22.1997C23.3617 22.8084 22.7071 23.1818 22 23.1818H2C1.29288 23.1818 0.638317 22.8084 0.27842 22.1997C-0.0814762 21.5911 -0.0932064 20.8376 0.247568 20.218L10.2476 2.03616C10.5991 1.39707 11.2706 1 12 1ZM3.1 19.1818L2 21.1818H4.28254H19.7175H22L20.9 19.1818L13.1413 5.07504L12 3L10.8587 5.07504L3.1 19.1818Z",
    fill: "#BF152C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21.1818L12 3L22 21.1818H2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 15.4375C12.7334 13.8625 13.0667 9.46563 13.0667 8.21875V7.5625H11.0667V8.21875C11.0667 9.46563 11.3334 13.8625 11.5334 15.4375H12.6Z",
    fill: "#BF152C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 18.0625,
    rx: 1.33333,
    ry: 1.3125,
    fill: "#BF152C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconError);
export default __webpack_public_path__ + "static/media/notification-icon-error.cf6b2d8f1f350494ffda4489d70abf73.svg";
export { ForwardRef as ReactComponent };